import React, { useContext, useState } from 'react';
import * as S from './styled';
import { useSnackbar } from 'notistack';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';
import { maskFieldDate, unmaskFieldDate } from '../utils';
import {
  defaulManyDepositsForm,
  defaultBlurManyDeposits,
} from '../../../../store/invoice/utils';

export default function FormDepositUpdateMany() {
  const {
    getInvoice,
    setInvoice,
    getFormMessage,
    validateForm,
    updateDeposits,
    setModal,
    filterDailyDeposit,
    filterDeposit,
    checkDepositIds,
  } = useContext(ExportContext)!.controllers.deposit;

  const { enqueueSnackbar } = useSnackbar();

  const getForm = <T extends FlattenKeys<ManyDepositsForm>>(field: T) =>
    getInvoice(`forms.deposits.updateMany.${field}`);

  const setForm = <
    T extends FlattenKeys<ManyDepositsForm>,
    V extends DeepType<InvoiceState, `forms.deposits.updateMany.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.deposits.updateMany.${field}`, value);

  const blurField = (field: keyof ManyDepositsForm) => () => {
    setInvoice(`blur.deposits.updateMany.${field}`, true);
  };
  const messages = getFormMessage('deposits.updateMany');

  const clearForm = () => {
    setInvoice(`forms.deposits.updateMany`, defaulManyDepositsForm());
    setInvoice(`blur.deposits.updateMany`, defaultBlurManyDeposits());
  };

  const [loading, setLoading] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    validateForm('deposits.updateMany')
      .then(() => {
        const length = checkDepositIds.length;
        updateDeposits()
          .then(() => {
            clearForm();
            setModal('single.updateManyDeposits', false);
            filterDailyDeposit();
            filterDeposit();
            enqueueSnackbar(
              length === 1
                ? `Depósito atualizado com sucesso`
                : `Depósitos atualizados com sucesso`,
              {
                variant: 'success',
              },
            );
          })
          .catch(() => {
            enqueueSnackbar(
              length === 1
                ? `Houve uma falha ao atualizar o depósito`
                : `Houve uma falha ao atualizar os depósitos`,
              {
                variant: 'error',
              },
            );
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid
          style={{
            gridTemplateColumns: '1fr',
          }}
        >
          <Form.Input.DatePicker
            label="Data de referência"
            value={maskFieldDate(getForm('reference'))}
            onChange={(e) =>
              setForm('reference', unmaskFieldDate(e.target.value))
            }
            error={messages.reference}
            onBlur={blurField('reference')}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Atualizar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
